import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable, Subscription, fromEvent } from 'rxjs';
import { Client } from '../../models/client.model';
import { CDCService } from '../../services/cdc.service';
import { IDictionary } from '../../shared/models/dictionary.model';
import { SaleService } from '../../services/sale.service';
import { Sale } from '../../models/sale.model';
import { MsAuthService } from '../../services/ms-auth.service';
import { OrderService } from "../../services/order.service";

@Component({
  selector: 'order-search-list',
  templateUrl: './order-search-list.component.html',
  styleUrls: ['./order-search-list.component.scss'],
})
export class OrderSearchListComponent implements OnInit, OnDestroy {
  @ViewChild(CdkVirtualScrollViewport)
  viewport: CdkVirtualScrollViewport;

  public currentArray: IDictionary[] = [];
  private _dataStream: BehaviorSubject<IDictionary[]> = new BehaviorSubject<
    IDictionary[]
  >([]);
  public dataStream$: Observable<IDictionary[]> =
    this._dataStream.asObservable();
  public theEnd = false;
  public loading = false;
  private _firstLoad = true;
  private _subscriptions = new Subscription();

  constructor(
    private _router: Router,
    public cdcService: CDCService,
    public msAuthService: MsAuthService,
    private _salesHistoryService: SaleService,
    private _orderService: OrderService,
  ) {}

  ngOnInit(): void {
    if (this._salesHistoryService.sales.length > 0) {
      this._subscriptions.add(
      this._salesHistoryService.sales$.subscribe((result : Sale[]) => {
        if(result.length < 1){
          this._router.navigateByUrl(`/client-search`);
        } else {
          this.currentArray = result;
          this._dataStream.next(this.currentArray);
        }
      }))
    } else {
      this._router.navigateByUrl(`/client-search`);
    }
  }

  ngAfterViewInit(): void {
    if(this.viewport) {
      this._subscriptions.add(fromEvent(this.viewport.elementRef.nativeElement,'scroll')
      .subscribe((e: Event) => {
        this._salesHistoryService.salesListYAxis = e.target['scrollTop']
      }));
    }
  }

  ngOnDestroy(): void {
    this._subscriptions.unsubscribe();
  }

  public nextBatch(): void {
    if (
      !this.loading &&
      !this.theEnd &&
      this.viewport &&
      this.viewport.getRenderedRange().end === this.viewport.getDataLength()
    )
      this.getBatch();
    if(this._firstLoad && this.viewport) {
      this._firstLoad = false;
      this.viewport.scrollTo({top: this._salesHistoryService.salesListYAxis});
    }
  }

  public saleClicked(sale: Sale): void {
    this._salesHistoryService.selectedSale = sale;
    if(sale.type === 'RETAILTRANSACTION') {
      this._router.navigateByUrl(`/transaction/${sale.id}/${sale.registerId}/${sale.initiatingLocation}/${sale.date.split('-').join('')}`, {
        skipLocationChange: false,
      });
    } else {
      this._router.navigateByUrl(`/order/${sale.id}`, {
        skipLocationChange: false,
      });
    }
  }

  public getName(client: Client): string {
    return client
      ? `${client.firstName} ${client.lastName}`
      : `UNKNOWN`;
  }

  public getPhone(client: Client): string {
    return client ? client.phone : `UNKNOWN`;
  }

  public getEmail(client: Client): string {
    return client ? client.email : `UNKNOWN`;
  }

  private getBatch(): void {
    if (this.currentArray.length > 0 && this.currentArray.length < this._salesHistoryService.totalSales){
      this.loading = true;
      this._subscriptions.add(
        this._salesHistoryService.getNextSaleHistory().subscribe((sales) => {
          this.loading = false;
        })
      );
    }
    if (this.currentArray.length >= this._salesHistoryService.totalSales){
      this.theEnd = true;
    }
  }
  
  public getSource(source: string|undefined): string {
    if(source && this._orderService.getSource(source)){
      return ` - ${this._orderService.getSource(source)}`;
    }
    return "";
  }
}
